import { BrowserService } from './browser.service';

export class NopService implements BrowserService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  openInNewTab(): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  changeLocationHref(): void {}

  getWindow(): Window | null {
    return null;
  }

  isBrowser(): boolean {
    return false;
  }

  copyToClipboard(): Promise<void> {
    return Promise.resolve();
  }
}
